module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"More information about the solutions for landowners","linkLabels":["In Lithuania","In Poland","In Italy"]}}')
  delete Component.options._Ctor
}
